import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { encryptRequestData } from "../../utils/crypto";
import { NavLogo } from "../../components/Navbar/NavbarElements";
import { SvgLogo } from "../Authentican/Profile/ProfileElements";
import navbarLogo from "../../assets/images/jobDashlogo.png";
// import { encryptRequestData } from "@/utils/encryption"; // adjust path if needed

const password = "e0m636izi4gnbz9htaxewtr5ogepbwai";

export default function DeleteAccount() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmed: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = () => {
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.confirmed
    ) {
      toast.error("Please fill all required fields and confirm deletion.", {
        position: "bottom-right",
      });
      return;
    }
    setShowConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    setShowConfirmModal(false);
    setIsSubmitting(true);
    setError(false);

    try {
      const requestData = {
        Name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        confirmed: formData.confirmed,
      };

      const encrypted = await encryptRequestData(requestData, password);

      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");

      const response = await fetch(
        "https://dev.jobdashflash.com/api/user/deleteUser",
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
          body: JSON.stringify({
            payload: encrypted.payload,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Something went wrong");
      }

      setShowSuccessModal(true);
      resetForm();
    } catch (err) {
      setError(true);
      setErrorMessage(err.message || "Unknown error occurred");
      setShowSuccessModal(true);
      resetForm();
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      confirmed: false,
    });
  };

  const Loader = () => (
    <div style={styles.loaderOverlay}>
      <div style={styles.loader} />
    </div>
  );

  return (
    <div style={styles.page}>
      <Toaster />
      {isSubmitting && <Loader />}


      <div style={styles.container}>

        <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>

          <NavLogo>
            {/* <NavLogo to={firstAllowedRoute}  onClick={() => navigate(firstAllowedRoute)}></NavLogo> */}
            <SvgLogo className="logoImage" src={navbarLogo} />
          </NavLogo>

          <span className="navbar-header">JobDash</span>
        </div>
        <h1 style={styles.title}>Delete Your Account</h1>

        <p style={styles.text}>
          You can delete your account from within the JobDash App.
        </p>
        <p style={styles.text}>
          Deleting your account is irreversible.
        </p>

        <h2 style={styles.subTitle}>STEPS TO DELETE YOUR ACCOUNT:</h2>
        <ol style={styles.list}>
          <li>Open the JobDash app.</li>
          <li>Go to Profile.</li>
          <li>Go to Settings.</li>
          <li>Select Delete Account.</li>
          <li>Confirm your request.</li>
        </ol>

        <h2 style={styles.subTitle}>DELETING YOUR ACCOUNT WILL:</h2>
        <ul style={styles.list}>
          <li>Remove your account from all devices.</li>
          <li>Erase transaction history.</li>
          <li>Unsubscribe notifications.</li>
          <li>Delete backups.</li>
        </ul>

        {/* FORM */}
        <div style={styles.formCard}>
          <h2 style={styles.formTitle}>Account Deletion Form</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name *"
            value={formData.firstName}
            onChange={handleInputChange}
            style={styles.input}
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name *"
            value={formData.lastName}
            onChange={handleInputChange}
            style={styles.input}
          />

          <input
            type="email"
            name="email"
            placeholder="Email *"
            value={formData.email}
            onChange={handleInputChange}
            style={styles.input}
          />

          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="confirmed"
              checked={formData.confirmed}
              onChange={handleInputChange}
            />
            <span style={{ marginLeft: 8 }}>
              Yes, delete my JobDash account
            </span>
          </label>

          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            style={styles.submitBtn}
          >
            Submit
          </button>
        </div>
      </div>

      {/* CONFIRM MODAL */}
      {showConfirmModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Confirm Account Deletion</h3>
            <p>This action cannot be undone.</p>
            <div style={styles.modalActions}>
              <button onClick={() => setShowConfirmModal(false)}
              style={{ height: "2.5rem" ,width: "7rem", border: "none", borderRadius: "0.5rem" }}
                >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                style={{ background: "red", color: "#fff", height: "2.5rem" ,width: "7rem", border: "none", borderRadius: "0.5rem" }}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SUCCESS / ERROR MODAL */}
      {showSuccessModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>{error ? "Error!" : "Success!"}</h3>
            <p>
              {error
                ? errorMessage
                : "Your account deletion request was submitted successfully."}
            </p>
            <button
              onClick={() => setShowSuccessModal(false)}
              style={{
                ...styles.submitBtn,
                background: error ? "red" : "green",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  page: { minHeight: "100vh", background: "#fff" },
  container: { maxWidth: 900, margin: "0 auto", padding: 40 },
  title: { fontSize: 32, marginBottom: 20 },
  text: { fontSize: 16, color: "#555" },
  subTitle: { marginTop: 40, fontSize: 20 },
  list: { marginLeft: 20, color: "#555" },
  formCard: {
    marginTop: 40,
    padding: 30,
    background: "#f7f7f7",
    borderRadius: 8,
  },
  formTitle: { fontSize: 24, marginBottom: 20 },
  input: {
    width: "100%",
    padding: 12,
    marginBottom: 15,
    borderRadius: 6,
    border: "1px solid #ccc",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  submitBtn: {
    width: "100%",
    padding: 12,
    background: "#5088FB",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
  },
  loaderOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  loader: {
    width: 40,
    height: 40,
    border: "4px solid #ddd",
    borderTop: "4px solid red",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    background: "#fff",
    padding: 25,
    borderRadius: 8,
    width: 350,
    textAlign: "center",
  },
  modalActions: {
    display: "flex",
    gap: 10,
    marginTop: 20,
  },
};
